import React from "react"

import {RecognitionFeed} from "@irati/types"
import {FeedItemType} from "@irati/recognition/enums"
import Poll from "./Poll"
import Recognition from "./Recognition"
import GroupCelebrationFeedCard from "./GroupCelebrationFeedCard"

interface FeedCardProps {
  item: RecognitionFeed
}
const CardComponents = {
  [FeedItemType.POLL]: Poll,
  [FeedItemType.RECOGNITION]: Recognition,
  [FeedItemType.GROUP_RECOGNITION]: GroupCelebrationFeedCard
}
const FeedCard: React.FC<FeedCardProps> = (props) => {
  const {item} = props

  const Component = CardComponents[item.type!]
  if (!Component) {
    return null
  }
  return <Component {...props} />
}
export default FeedCard
